'use client'

import { Utils } from "@/lib/utils";
import { useMemo } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";

interface ProfileAvatarProps {
      image: string | null;
      name: string | null;
}

const ProfileAvatar = ({ image, name }: ProfileAvatarProps) => {

      const imageUrl = useMemo(() => {
            return Utils.image.getUserImageUrl(image || "");
      }, [image]);

      return (
            <Avatar className="w-5 h-5">
                  {imageUrl && <AvatarImage src={imageUrl} loading="lazy" />}
                  <AvatarFallback className="bg-kiwilog text-white uppercase">
                        {name?.substring(0, 2)}
                  </AvatarFallback>
            </Avatar>
      );
};

export default ProfileAvatar;
